
import { useApiQuery } from './useApiQuery'
import { apiRoutes } from './apiRoutes'
import { PortalOrgUiConfigLink, PortalOrgUiConfigSections } from '../types/portalTypes/PortalDomainOrg'
import { useIsPinPage } from './useIsPinPage';


export interface UserConfigResponse {
  roles: string[];
  uiConfig: {
    Links?: PortalOrgUiConfigLink[];
    Sections?: PortalOrgUiConfigSections;
  } | null;
}

// New hook name to match established pattern (useGetX)
export function useGetUserConfig(options: { enabled: boolean }) {
  // Query runs only when explicitly enabled by the caller and the current page is not a PIN page.
  const isPinPage = useIsPinPage();
  const enabled = options.enabled && !isPinPage
  const query = useApiQuery<UserConfigResponse>(apiRoutes.getUserConfig(), {
    enabled,
    staleTime: 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 1,
    // Custom select or error handling could go here later
  })
  return query
}

// Backward compatible export; prefer useGetUserConfig going forward.
export const useUserConfig = (enabled: boolean) => useGetUserConfig({ enabled })
